(function () {
  if (typeof gtag !== 'function') return;

  /* ── add_to_cart ── */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source !== 'product-form') return;

      var cartData = event.cartData;
      if (!cartData) return;

      // Shopify /cart/add.js returns the added item at the top level
      // (with a `sections` object alongside), not inside an `items` array
      var item = cartData.items ? cartData.items[0] : cartData;
      if (!item || !item.id) return;

      gtag('event', 'add_to_cart', {
        currency: cartData.currency || item.currency || 'GBP',
        value: (item.final_line_price || item.price) / 100,
        items: [{
          item_id: String(item.id),
          item_name: item.product_title || item.title,
          price: item.price / 100,
          item_variant: item.variant_title || undefined,
          quantity: item.quantity || 1
        }]
      });
    });
  }

  /* ── begin_checkout ── */
  document.addEventListener('click', function (e) {
    var button = e.target.closest('#checkout, #CartDrawer-Checkout');
    if (!button) return;

    var dataEl = button.id === 'CartDrawer-Checkout'
      ? document.getElementById('interval-ga4-cart-data-drawer')
      : document.getElementById('interval-ga4-cart-data-page');

    if (!dataEl) return;

    try {
      var cartData = JSON.parse(dataEl.textContent);
      gtag('event', 'begin_checkout', {
        currency: cartData.currency,
        value: cartData.total_price / 100,
        items: cartData.items
      });
    } catch (err) {
      // Silently fail — do not block checkout
    }
  });
})();
